var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-headline-wrap"},[_c('img',{staticClass:"modal-headline",attrs:{"src":"/images/headline-modal.png","alt":"Headline Modal Title"}})])
}]

export { render, staticRenderFns }